/* repo/configuration */
import { fetch as fetchApi } from "./api";

const FIELD_ATTRIBUTES_ENDPOINT = "field-attributes";

interface ConfigurationResponse {
  success: boolean;
  data: string[];
  donotrender: string[];
}

export async function fetchFieldAttributeConfig(): Promise<{ data: string[]; donotrender: string[] }> {
  return fetchApi({
    nestedResourcePath: [FIELD_ATTRIBUTES_ENDPOINT],
    id: null,
    params: {},
  }).then((response) => {
    const configResponse = response.data as ConfigurationResponse;
    if (configResponse.success) {
      return {
        data: configResponse.data || [],
        donotrender: configResponse.donotrender || []
      };
    } else {
      throw new Error("Failed to fetch field attribute configuration");
    }
  });
}

export async function fetchAllFieldAttributeConfigs(): Promise<Record<string, string[]>> {
  return fetchApi({
    nestedResourcePath: ["configuration", "field-attributes", "all"],
    id: null,
    params: {},
  }).then((response) => {
    const configResponse = response.data as { success: boolean; data: Record<string, string[]> };
    if (configResponse.success) {
      return configResponse.data;
    } else {
      throw new Error("Failed to fetch all field attribute configurations");
    }
  });
} 